import { format } from "date-fns";

import type { ContractionsFlowsheetFormValues } from "@/encounters/components/EncounterLabor/flowsheet-forms/contractions/types/contractions-form";
import type { ContractionsFlowsheetFormSchemaType } from "@/encounters/components/EncounterLabor/flowsheet-forms/contractions/zod-schemas/contractions-flowsheet-form";
import { localToUtcTimeString } from "@/utils/timeUtils";

/** Empty hydrate shape (null datetime). Used when editing/mapping a QR — not for a new quick-add form. */
export function getEmptyContractionsFlowsheetFormValues(): ContractionsFlowsheetFormValues {
  return {
    contractionDate: null,
    contractionTime: null,
    frequency: "",
    duration: "",
    strength: null,
    coping: null,
    notes: "",
    signatureInitials: [],
  };
}

/** Defaults for a new quick-add form (current local date/time prefilled). */
export function getDefaultContractionsFlowsheetFormValues(): ContractionsFlowsheetFormValues {
  const now = new Date();
  const localTime = format(now, "HH:mm:ss");
  return {
    ...getEmptyContractionsFlowsheetFormValues(),
    contractionDate: now,
    contractionTime: localToUtcTimeString(localTime),
  };
}

export function normalizeContractionsFlowsheetFormValues(
  parsed: ContractionsFlowsheetFormSchemaType,
): ContractionsFlowsheetFormValues {
  // Preserve explicit null date/time (cleared or omitted clinical datetime). Do not fall back to
  // "now" via ?? — that belongs only on new-form defaults.
  const empty = getEmptyContractionsFlowsheetFormValues();
  return {
    contractionDate:
      parsed.contractionDate !== undefined ? parsed.contractionDate : empty.contractionDate,
    contractionTime:
      parsed.contractionTime !== undefined ? parsed.contractionTime : empty.contractionTime,
    frequency: parsed.frequency ?? empty.frequency,
    duration: parsed.duration ?? empty.duration,
    strength: parsed.strength ?? empty.strength,
    coping: parsed.coping ?? empty.coping,
    notes: parsed.notes ?? empty.notes,
    signatureInitials: parsed.signatureInitials ?? empty.signatureInitials,
  };
}
